import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';
import { ConfirmacaoDaAcao } from 'components/task-item/modal-actions/moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
}

/** Bonificar a Ação ECOA (ECN-57), na moldura da nova identidade. */
export default function ModalDouble(props: Props) {
  const modalID = 'validation-double';

  const { openModal, closeModal } = useModal();
  const { callback, id } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  return (
    <ConfirmacaoDaAcao
      title="Bonificar Ação ECOA"
      onClose={() => closeModal()}
      onConfirm={() => {
        callback({ id: 'double' });
        closeModal();
      }}
    >
      <p className="m-0">
        Ao bonificar uma Ação ECOA, ela recebe 300 pontos! Lembre-se, você pode bonificar 1 (uma) Ação das que chegaram a etapa
        final de apreciação. Deseja Confirmar essa opção?
      </p>
    </ConfirmacaoDaAcao>
  );
}
